module.exports = __webpack_public_path__ + "img/hlm-mooring-tug-4.f465def0.jpg";